<template>
	<div id="body-container" class="pt-0">
		<slot />
	</div>
</template>
<style  scoped>
</style>